import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { CentersRedux } from '../Redux/CentersRedux'

const centersCrudObservable = createCRUDObservable({
  mainRedux: CentersRedux,
  reduxPath: 'centers',
})

export const centersObservers = Object.assign({}, centersCrudObservable.observers, {})

export const centersEpic = combineEpics(
  centersCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CentersObservable.js